module.exports = __webpack_public_path__ + "img/5.7de6db6a.jpg";